// biome-ignore lint/style/noRestrictedImports: legacy code - style/noRestrictedImports
import styled from 'styled-components';

export const Wrapper = styled.div<{ bgDesktop?: string; bgMobile?: string }>`
  background-image: ${({ bgMobile }) => `url(${bgMobile})` || 'none'};
  background-position: top center;
  background-repeat: no-repeat;
  background-origin: top;
  background-size: cover;

  ${({ theme }) => theme.breakpoints.up('md')} {
    min-height: 740px;
    background-image: ${({ bgDesktop }) => `url(${bgDesktop})` || 'none'};
  }
`;

export const LeftContent = styled.div`
  max-width: 540px;
`;
